<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i> Transações
                <a href="javascript:window.history.back();" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </a>
            </div>
            <b-card-body>
                <h4>{{model.sellerName}}</h4>
                <hr class="mb-5" />
                <form>
                    <div class="form-row justify-content-start">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Código</label>
                                <input disabled type="text" :value="model.code" class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label>Data</label>
                                <input disabled type="text" :value="transactionDate" class="form-control-plaintext" />                                
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Tipo</label>
                                <input disabled type="text" :value="model.origin == 'Device' ? 'Presencial' : 'Web'"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group" v-if="model.origin == 'Device'">
                                <label>No. Serie Maquininha</label>
                                <input disabled type="text" :value="model.serialNumber"  class="form-control-plaintext" />                                
                            </div>
                            <div class="form-group" v-else>
                                <label>Link de pagamento</label>
                                <input disabled type="text" :value="model.paymentLink"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Tipo operação</label>
                                <div class="form-control-plaintext"><span style="font-weight:bold;">{{`${model.paymentMethodTypeName} (${model.installmentCount}x)`}}</span><img width="30px" :src="model.paymentMethodImage"></div>                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Dados adicionais</label>
                                <input disabled type="text" :value="`${model.holder}`"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                    </div>
                    <hr class="mt-3 mb-5" />
                    <div class="form-row justify-content-start">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Valor bruto</label>
                                <input disabled type="text" :value="grossAmount"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Taxa</label>
                                <input disabled type="text" :value="partnerFeeWithTax"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Antecipação</label>
                                <input disabled type="text" :value="advanceOnReceivables"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Valor líquido</label>
                                <input disabled type="text" :value="netAmount"  class="form-control-plaintext" />                                
                            </div>
                        </div>                                                
                    </div>
                    <hr class="mt-3 mb-5" />
                    <div class="form-row justify-content-start">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Comissão intermediação</label>
                                <input disabled type="text" :value="salesPersonAmount"  class="form-control-plaintext" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Comissão antecipação</label>
                                <input disabled type="text" :value="salesPersonAdvanceOnReceivables"  class="form-control-plaintext" />                                
                            </div>
                        </div>                                                                       
                    </div>
                </form>
            </b-card-body>
        </b-card>
        <b-card>
            <h4>Liberação de valores</h4>
            <hr class="mb-5" />
            <c-table
                :table-data="installments"
                :fields="fields"
                :striped="true"                
            ></c-table>
        </b-card>
    </div>
</template>
<script>
import cTable from "../../components/base/Table.vue";
import editPage from '../../mixins/editPage'
import transactionService from "../../services/Transactions/transactionService";
import moment from 'moment';
export default {
    props: {
        id: String
    },
    components: {
        cTable    
    },
    mixins: [editPage],
    data() {
        return {
            actionUri: '',
            model: {
                date: '',
                sellerName: '',
                origin: 'Device',
                paymentLink: '',
                grossAmount: 0,
                netAmount: 0,
                installmentCount: 1,
                paymentMethodName: '',
                paymentMethodTypeName: '',                
                paymentMethodImage: '',
                serialNumber: '',
                holder: '',
                fee: 0.0,
                advanceOnReceivablesFee: 0.0,
                feeAmount: 0.0,
                salespersonAmount: 0.0,
                advanceOnReceivablesAmount: 0.0,
                salespersonAdvanceOnReceivablesAmount: 0.0,
                installments:[]
            },
            fields: [
                { key: "parcelFormatted", label: "Parcela", sortable: false },
                { key: "date", label: "Data Liberação", sortable: false },                
                { key: "grossAmountFormatted", label: "Valor Bruto", sortable: false },
                { key: "partnerFeeFormatted", label: "Taxa", sortable: false },
                { key: "advanceOnReceivablesFormatted", label: "Antecipação", sortable: false },
                { key: "netAmount", label: "Valor Liquido", sortable: false }                
            ]
        }
    },
    created(){
        this.fetchData()
    },
    computed: {
        grossAmount() {
            return this.model.grossAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        transactionDate() {
            return moment(this.model.date).format('DD/MM/YYYY - HH:mm:ss');
        },
        partnerFee() {
            return this.model.fee.toLocaleString('pt-BR', { style: 'decimal' });
        },
        partnerFeeAmount() {            
            return this.model.feeAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        netAmount() {            
            return this.model.netAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        salesPersonAmount() {            
            return this.model.salespersonAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },        
        partnerFeeWithTax() {
            return `${this.partnerFee}% | ${this.partnerFeeAmount}`;
        },
        advanceOnReceivables() {
            return this.model.advanceOnReceivablesAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        salesPersonAdvanceOnReceivables() {
            return this.model.salespersonAdvanceOnReceivablesAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        installments(){
            let result = [];
            for (let index = 0; index < this.model.installments.length; index++) {
                const transaction = this.model.installments[index];
                transaction.date = transaction.escrowDate;
                transaction.parcelFormatted = `${transaction.installmentCount} de ${this.model.installmentCount}`
                transaction.grossAmountFormatted = transaction.grossAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                transaction.netAmountFormatted = transaction.netAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                transaction.partnerFeeFormatted = `${this.partnerFee}% | ${transaction.feeAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`
                transaction.advanceOnReceivablesFormatted = `${transaction.advanceOnReceivablesAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} | <strong>${transaction.advanceOnReceivablesDays} dias</strong>`
                result.push(transaction);
            }
            return {
                pageIndex: 1,
                pageCount: 1,
                tableCount: result.length,
                data: result
            };
        }
    },
    methods:{
        fetchData() {
            const self = this;
            self.showLoading();
            transactionService.find(this.id).then(
                response => {
                    self.model = response.data;                    
                    self.hideLoading();
                },
                error => {
                    self.showError(error.response.data.result.errors[0].description);
                    self.hideLoading();
                }
            );
        }
    }
}
</script>
<style scoped>
.form-control-plaintext {
    font-weight: bold !important
    ;
}
</style>